import React, { useEffect, useState } from 'react';
import { Collapse, Tag, Spin, Empty, Progress, Typography } from 'antd';
import { ClockCircleOutlined, UserOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import api from '../api/axios';
import WorkTaskPendingPanel from '../components/dashboard/WorkTaskPendingPanel';
import BirthdaysPanel from '../components/dashboard/BirthdaysPanel';

const { Text } = Typography;

const InternDashboard = () => {
  const [slots, setSlots]     = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/intern/today')
      .then(res => setSlots(res.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center" style={{ minHeight: 300 }}>
        <Spin size="large" />
      </div>
    );
  }

  const items = slots.map((slot, idx) => ({
    key: idx,
    label: (
      <div className="flex items-center gap-2">
        <ClockCircleOutlined style={{ color: '#1677ff' }} />
        <span className="font-medium">{slot.start_time} – {slot.end_time}</span>
        <Tag color="blue">{slot.classroom_name}</Tag>
        <span className="ml-auto text-xs text-gray-400">{slot.students.length} öğrenci</span>
      </div>
    ),
    children: slot.students.length === 0 ? (
      <Text type="secondary">Kayıtlı öğrenci yok.</Text>
    ) : (
      <div className="flex flex-col gap-3">
        {slot.students.map((s, i) => (
          <div key={i} className="p-3 rounded-lg border" style={{ background: '#f8faff', borderColor: '#e0e7ff' }}>
            <div className="flex items-center gap-2 mb-1">
              <UserOutlined style={{ color: '#6366f1' }} />
              <span className="font-semibold text-gray-800">{s.student_name}</span>
              <span className="ml-auto text-xs text-gray-400">
                {s.completed_count}/{s.total_topics} proje
              </span>
            </div>

            {s.course_name && (
              <div className="text-xs text-gray-500 mb-2">{s.course_name}</div>
            )}

            {s.total_topics > 0 && (
              <Progress
                percent={s.total_topics > 0 ? Math.round((s.completed_count / s.total_topics) * 100) : 0}
                size="small"
                showInfo={false}
                strokeColor="#1677ff"
                style={{ marginBottom: 6 }}
              />
            )}

            {s.current_topic ? (
              <div className="flex items-center gap-1 mt-1">
                <span className="text-xs text-gray-500">Sıradaki proje:</span>
                <Tag color="orange" style={{ fontSize: 12 }}>{s.current_topic.name}</Tag>
              </div>
            ) : (
              <Tag color="green" style={{ fontSize: 12 }}>Tüm projeler tamamlandı ✓</Tag>
            )}
          </div>
        ))}
      </div>
    ),
  }));

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-xl font-bold text-gray-800">Bugünkü Program</h2>
        <Text type="secondary">{dayjs().format('DD MMMM YYYY dddd')}</Text>
      </div>

      <WorkTaskPendingPanel />
      <BirthdaysPanel />

      {slots.length === 0 ? (
        <Empty description="Bugün için program bulunamadı." />
      ) : (
        <Collapse items={items} />
      )}
    </div>
  );
};

export default InternDashboard;
